import { useEffect, useMemo } from "react";
import type { FiatPrice } from "@b2bportal/air-shopping-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  useGetWalletCreditSummaryQuery,
  getCreditBalance,
  defaultBalance,
} from "@hsbc/wallet";

interface UseCreditsBalanceReturn {
  creditBalance: FiatPrice;
  totalCredits: string;
  isLoading: boolean;
}

export const useCreditsBalance = (
  forceRefetch?: boolean
): UseCreditsBalanceReturn => {
  const { formatFiatCurrency } = useI18nContext();
  const { data, refetch, isFetching, isLoading } =
    useGetWalletCreditSummaryQuery(undefined);
  const creditBalance = getCreditBalance(data) || defaultBalance;

  useEffect(() => {
    if (forceRefetch && refetch) {
      refetch();
    }
  }, [forceRefetch, refetch]);

  const formattedBalance = useMemo(
    () => (creditBalance.currencyCode ? formatFiatCurrency(creditBalance) : ""),
    [creditBalance, formatFiatCurrency]
  );

  return {
    creditBalance,
    totalCredits: formattedBalance,
    isLoading: isFetching || isLoading,
  };
};
